export const BaruDiajukan = "Baru diajukan";
export const Diajukan = "Diajukan";
export const DipertanggungJawabkan = "Dipertanggung Jawabkan";
export const Diverifikasi = "Diverifikasi";
export const Dibayarkan = "Dibayarkan";
export const Ditolak = "Ditolak";
export const Diterima = "Diterima";
export const Dikembalikan = "Dikembalikan";

export const STATUS_DATA_TYPE = {
  UMK: "umk",
  UMO: "umo",
  Transaksi: "transaksi",
  Realokasi: "realokasi",
  RencanaImplementasi: "rencanaimplementasi",
  AkunBaru: "akunbaru",
  GroupTransaksi: "grouptransaksi",
  DokumenTransaksi: "dokumentransaksi",
};

export const StatusDataUMK = [
  { id: 1, nama_status: BaruDiajukan, color: "primary" },
  { id: 2, nama_status: DipertanggungJawabkan, color: "warning" },
  { id: 3, nama_status: Diverifikasi, color: "warning" },
  { id: 4, nama_status: Dibayarkan, color: "success" },
  { id: 5, nama_status: Ditolak, color: "danger" },
];

export const StatusDataUMO = [
  { id: 1, nama_status: BaruDiajukan, color: "primary" },
  { id: 2, nama_status: DipertanggungJawabkan, color: "warning" },
  { id: 3, nama_status: Diverifikasi, color: "warning" },
  { id: 4, nama_status: Dibayarkan, color: "success" },
  { id: 5, nama_status: Ditolak, color: "danger" },
];

export const StatusDataTransaksi = [
  { id: 1, nama_status: BaruDiajukan, color: "primary" },
  { id: 2, nama_status: DipertanggungJawabkan, color: "warning" },
  { id: 3, nama_status: Diverifikasi, color: "warning" },
  { id: 4, nama_status: Dibayarkan, color: "success" },
  { id: 5, nama_status: Ditolak, color: "danger" },
];

export const StatusDataRealokasi = [
  { id: 1, nama_status: BaruDiajukan, color: "primary" },
  // { id: 2, nama_status: DipertanggungJawabkan, color: "warning" },
  { id: 3, nama_status: Diverifikasi, color: "warning" },
  { id: 4, nama_status: Diterima, color: "success" },
  { id: 5, nama_status: Ditolak, color: "danger" },
];

export const StatusDataRencanaImplementasi = [
  { id: 1, nama_status: BaruDiajukan, color: "primary" },
  { id: 2, nama_status: DipertanggungJawabkan, color: "warning" },
  { id: 3, nama_status: Diverifikasi, color: "warning" },
  { id: 4, nama_status: Dibayarkan, color: "success" },
  { id: 5, nama_status: Ditolak, color: "danger" },
];

export const StatusDataAkunBaru = [
  { id: Diajukan, nama_status: Diajukan, color: "primary" },
  { id: Diterima, nama_status: Diterima, color: "success" },
];

export const StatusDataDokumenTransaksi = [
  { id: 1, nama_status: Diajukan, color: "primary" },
  { id: 2, nama_status: Diterima, color: "success" },
  { id: 3, nama_status: Ditolak, color: "danger" },
  { id: 4, nama_status: Dikembalikan, color: "warning" },
];

export const getStatusData = (id, type) => {
  let status;
  switch (type) {
    case STATUS_DATA_TYPE.UMK:
      status = StatusDataUMK.find((item) => item.id === id);
      break;
    case STATUS_DATA_TYPE.UMO:
      status = StatusDataUMO.find((item) => item.id === id);
      break;
    case STATUS_DATA_TYPE.Transaksi:
      status = StatusDataTransaksi.find((item) => item.id === id);
      break;
    case STATUS_DATA_TYPE.Realokasi:
      status = StatusDataRealokasi.find((item) => item.id === id);
      break;
    case STATUS_DATA_TYPE.RencanaImplementasi:
      status = StatusDataRencanaImplementasi.find((item) => item.id === id);
      break;
    case STATUS_DATA_TYPE.AkunBaru:
      status = StatusDataAkunBaru.find((item) => item.id === id);
      break;
    case STATUS_DATA_TYPE.DokumenTransaksi:
      status = StatusDataDokumenTransaksi.find((item) => item.id === id);
      break;
  }
  return status ? status : null;
};

export const getStatusDataName = (id, type) => {
  const status = getStatusData(id, type);
  return status ? status.nama_status : "";
};

export const canAccessWhenStatus = (idStatus, type, listStatus) =>
  listStatus.filter((status) => getStatusDataName(idStatus, type) === status)
    .length > 0;

export const canAccessWhenStatusNot = (idStatus, type, listStatus) =>
  listStatus.filter((status) => getStatusDataName(idStatus, type) === status)
    .length == 0;
